const options = {
  5: "bg-slate-900/5",
  10: "bg-slate-900/10",
  25: "bg-slate-900/25",
  50: "bg-slate-900/50",
  75: "bg-slate-900/75",
  90: "bg-slate-900/90",
  100: "bg-slate-900",
};

const from = {
  5: "from-slate-900/5",
  10: "from-slate-900/10",
  25: "from-slate-900/25",
  50: "from-slate-900/50",
  75: "from-slate-900/75",
  90: "from-slate-900/90",
  100: "from-slate-900",
};

export default function getBackgroundSlate900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
